"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Link_1 = __importDefault(require("../Link"));
var TabNav = function (_a) {
    var links = _a.links, linkEl = _a.linkEl;
    var linkClasses = 'px-3 py-2 rounded-lg leading-none';
    var lastIndex = links.length - 1;
    return (react_1.default.createElement("div", { className: "bg-gray-light rounded-lg inline-flex p-1" }, links.map(function (_a, index) {
        var label = _a.label, active = _a.active, href = _a.href, onClick = _a.onClick, key = _a.key;
        return (react_1.default.createElement(Link_1.default, { use: linkEl, key: key || "tabnav-" + index, href: href || '', onClick: onClick, className: linkClasses + " " + (index === lastIndex ? 'mr-0' : 'mr-1') + " " + (active ? 'text-blue bg-white hover:text-blue' : 'text-black hover:text-blue') }, label));
    })));
};
exports.default = TabNav;
//# sourceMappingURL=TabNav.js.map